import { keepPreviousData, useQuery } from '@tanstack/react-query';

import getHostSchedule from 'Api/host/getHostSchedule';

import { useHostScheduleState } from 'View/host-schedule/state';

import getHostScheduleRequest from './model/request/getHostScheduleRequest';
import getHostScheduleResponse from './model/response/getHostScheduleResponse';
import checkIsHostScheduleEnabled from './helper/checkIsHostScheduleEnabled';

const useGetHostSchedule = () => {
  const { updateState, state, filterState } = useHostScheduleState();

  const isEnabled = checkIsHostScheduleEnabled(filterState);

  return useQuery({
    queryKey: ['host-schedule', filterState],
    queryFn: async () => {
      const queries = getHostScheduleRequest(filterState);

      const response = await getHostSchedule(queries);

      const result = getHostScheduleResponse(response, state?.previousDailySchedule, filterState?.page);

      updateState({ previousDailySchedule: result?.dailySchedules });

      return result;
    },
    refetchOnWindowFocus: false,
    retry: false,
    gcTime: 0,
    enabled: isEnabled,
    placeholderData: keepPreviousData,
  });
};

export default useGetHostSchedule;
